import axios from "axios"
import baseURL from "../config/api"

export const delete_Device = (primaryKey: number, token: string) => {
    return axios({
        url: `${baseURL}device`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey }
    }).then(response => response.data);
}

export const delete_BulkDevice = (
    deviceIds: number[],
    userId: number,
    token: string
) => {
    return axios({
        url: `${baseURL}device/DeleteBulkDevice`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json-patch+json",
        },
        params: {
            userId,
        },
        data: deviceIds,
    }).then(response => response.data);
};

export const getDevices = (groupId: number, page: number, size: number, token: string) => {
    return getFetch(`device/GetDevicesPagination/${groupId},${page},${size}`, token)
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}